import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class ProjectionService {
	private readonly uri: string = `${environment.DO_URL}/v1`;

	constructor(private readonly http: HttpClient) { }

	// Application CRUD operations
	getProjection(year, month): Observable<any> {
		return this.http.get(`${this.uri}/projection/${year}/${month}`);
	}

	upsertProjection(data: any): Observable<any> {
		return this.http.put(`${this.uri}/projection/${data.year}/${data.month}`, data);
	}
}
